export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const isValidEmail = (input) => {
  return emailRegex.test(input);
};
